<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime: 2026-06-16 14:39:22
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 工艺流程
 * @FilePath     : \icps_fb\src\views\platform\ICPS\basicConfig\proflow.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <div v-if="ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1" style="margin: 5px; border-bottom: 1px solid #ddd; padding-bottom: 5px">
        <el-button size="small" class="bottom_all" style="margin-left: 0" @click="pagesaddFromDate('设置默认')"> 维护默认工艺流程 </el-button>
      </div>
      <el-main style="display: flex">
        <div v-loading="treeLoading" class="tree">
          <el-tree ref="tree" :data="treeData" default-expand-all :expand-on-click-node="false">
            <span slot-scope="{ node, data }" class="custom-tree-node tree-line">
              <span v-if="data.children">
                <i :class="data.icon"></i>
                <span>{{ node.label }}</span>
              </span>
              <el-radio-group v-else v-model="activetree">
                <el-radio :label="data.value" @click="activetreeName = node.label">
                  <span>{{ node.label }}</span>
                </el-radio>
              </el-radio-group>
            </span>
          </el-tree>
        </div>
        <div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <div class="dialoginfo-info">
                <div class="a">管控业务点：</div>
                <div class="b">
                  <el-checkbox-group v-model="buspointids">
                    <template v-for="(item, index) in buspointarr">
                      <div :key="index" class="checkbox-bg">
                        <el-checkbox :label="item.id">{{ item.itemName }}</el-checkbox>
                      </div>
                    </template>
                  </el-checkbox-group>
                </div>
              </div>
              <div class="dialoginfo-info">
                <div class="a">特殊业务：</div>
                <div class="b">
                  <el-button size="small" class="bottom_all" @click="surplusMaterialSet()">余料比例设置</el-button>
                  <el-button class="bottom_all" style="margin-left: 50px" @click="exceptionPerson()">异常处理推送人员设置</el-button>
                  <el-button class="bottom_all" style="margin-left: 50px" @click="productSet()">产品设置</el-button>
                  <el-button class="bottom_all" style="margin-left: 50px" @click="lineSet()">生产线设置</el-button>
                  <el-button class="bottom_all" style="margin-left: 50px" @click="marginSet()">富余量设置</el-button>
                  <span style="display: inline-block; margin-left: 50px;">
                    <span style="font-size: 14px; color: #606266;">自动取样时间：</span>
                    <el-input v-model="sampleTimeForm.sampleTime" style="width: 150px" type="number" :min="0" placeholder="请输入" clearable>
                      <template slot="append">s</template>
                    </el-input>
                  </span>
                  <span style="display: inline-block; margin-left: 20px;">
                    <span style="font-size: 14px; color: #606266;">延迟取样时间：</span>
                    <el-input v-model="sampleTimeForm.putOffSampleTime" style="width: 150px" type="number" :min="0" placeholder="请输入" clearable>
                      <template slot="append">s</template>
                    </el-input>
                  </span>
                </div>
              </div>
              <div style="margin: auto; text-align: center">
                <el-button class="bottom_all" style="width: 100px; margin-top: 50px" @click="pagessubmitFromDate()">保 存</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <!-- 添加 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="680px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo" style="padding: 0">
        <div class="dialoginfo-info">
          <div class="a">管控业务点：</div>
          <div class="b">
            <el-checkbox-group v-model="buspointids">
              <template v-for="(item, index) in buspointarr">
                <div :key="index" class="checkbox-bg">
                  <el-checkbox :label="item.id">{{ item.itemName }}</el-checkbox>
                </div>
              </template>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="pagessubmitFromDate(true)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 异常处理推送人员设置 -->
    <el-dialog v-dialogDrag :visible.sync="exceptionPersonDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">异常处理人员配置</span>
      <div class="dialoginfo" style="padding: 0">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="exceptionData" tooltip-effect="dark">
          <el-table-column label="异常类型" align="center" prop="exceptionName"> </el-table-column>
          <el-table-column label="异常处理人" align="center" prop="exceptionName">
            <template slot-scope="scope">
              <el-select v-model="scope.row.roleIdList" multiple @change="setList(scope.$index)">
                <el-option v-for="(item, index) in roleList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="exceptionPersonDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveExceptionPerson()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 余料比例设置 -->
    <el-dialog :visible.sync="surplusMaterialDig" width="500px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">余料比例设置</span>
      <div class="dialoginfo">
        <el-form ref="surplusMaterialForm" :rules="surplusMaterialRules" :inline="true" :model="surplusMaterialForm" label-width="110px">
          <el-form-item label="需要过磅"> </el-form-item>
          <el-form-item prop="proportion" label="比例">
            <el-input v-model="surplusMaterialForm.proportion" placeholder="请输入" clearable>
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="不需要过磅"> </el-form-item>
          <el-form-item prop="graphicCalc" label="图算">
            <el-input v-model="surplusMaterialForm.graphicCalc" placeholder="请输入" clearable>
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="actualConclude" label="实结">
            <el-input v-model="surplusMaterialForm.actualConclude" placeholder="请输入" clearable>
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="doubleControl" label="双控">
            <el-input v-model="surplusMaterialForm.doubleControl" placeholder="请输入" clearable>
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="surplusMaterialDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveSurplusMaterial()">保存</el-button>
      </span>
    </el-dialog>
    <!-- 产品设置 -->
    <el-dialog v-dialogDrag :visible.sync="productDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">产品设置</span>
      <div class="dialoginfo" style="padding: 0">
        <span>
        <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addProduct()"> 添加 </el-button>
        <span style="margin-left: 12px">(特殊产品配合比编号8888)</span>
        </span>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="productData" tooltip-effect="dark">
          <el-table-column label="产品名称" align="center" prop="productName">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productName" style="width: 150px" placeholder="请输入" clearable> </el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否传工控" align="center" prop="whetherSend">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.whetherSend" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"> </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" prop="whetherSend">
            <template slot-scope="scope">
              <el-button size="small" class="bottom_two" @click="DeleteProduct(scope.$index)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="productDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveProduct()">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 生产线设置 -->
    <el-dialog v-loading="saveLoad" :visible.sync="lineDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">生产线设置</span>
      <div class="dialoginfo" style="padding: 0">
        <el-row>
          <el-col :span="2" :offset="2"><span> 组数:</span></el-col>
          <el-col :span="18" :offset="2"> <el-input v-model="groupNum" style="width: 150px" type="number" :min="1" placeholder="请输入" clearable @input="groupInput" @change="setLineData"> </el-input></el-col>
        </el-row>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="lineData" tooltip-effect="dark">
          <el-table-column label="组数" align="center" prop="groupNum"> </el-table-column>
          <el-table-column label="生产线" align="center" prop="whetherSend">
            <template slot-scope="scope">
              <el-select v-model="scope.row.lineIdList" multiple @change="setLineList(scope.$index)">
                <el-option v-for="(item, index) in lineList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="lineDig = false">取 消</el-button>
        <el-button class="bottom_all" :disabled="saveDisabled" style="margin-left: 24px" @click="saveLine()">保 存</el-button>
      </span>
    </el-dialog>
        <!-- 富余量设置 -->
        <el-dialog v-loading="saveLoad" :visible.sync="marginDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">富余量设置</span>
      <div class="dialoginfo" style="padding: 0">
        <el-row>
          <el-col :span="22" :offset="2">票面量小于等于 <el-input v-model="marginForm.limitNum" style="width: 150px" type="number" :min="0" placeholder="请输入" clearable > </el-input>方，不扣减富余量。</el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="marginDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveMargin()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  getPointData,
  saveOrUpdate,
  queryProcesses,
  updatePointData,
  getExceptionUser,
  saveExceptionUser,
  selectCloutSetting,
  updateCloutSetting,
  queryProduct,
  saveProduct,
  queryLineByStation,
  queryLineGroup,
  saveLineGroup,
  queryLimit,
  saveLimit
} from "@/api/basicConfig/proflow.js";
import { getDicType } from "@/api/common.js";
import { getUserAutList } from "@/api/common.js";
export default {
  mixins: [mixin],
  data() {
    return {
      activetree: "",
      activetreeName: "",
      /*表格数据*/
      table: [
        { label: "管控业务点", width: "auto", prop: "name", status: true },
        { label: "操作", width: "120", prop: "", status: true },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 1,
      treeData: [],
      fromDate: {
        code: "",
      },
      navlist: [
        // { code: "market", name: "市场拓展" },
        { code: "nomarket", name: "非市场拓展" },
        { code: "collaboration", name: "往来协作" },
        { code: "personaluse", name: "自用" },
      ],
      tableData: [],
      activenav: "market",
      buspointarr: [],
      buspointids: [],
      buspointtotal: [],
      isAll: false,
      exceptionPersonDig: false,
      exceptionData: [
        {
          exceptionName: "前场异常",
          exceptionId: 1,
          stationId: "",
          stationName: "",
          list: [],
          roleIdList: [],
        },
        {
          exceptionName: "运输异常",
          exceptionId: 2,
          stationId: "",
          stationName: "",
          list: [],
          roleIdList: [],
        },
        {
          exceptionName: "图算超量异常",
          exceptionId: 3,
          stationId: "",
          stationName: "",
          list: [],
          roleIdList: [],
        },
        {
          exceptionName: "泵工扫泵异常",
          exceptionId: 4,
          stationId: "",
          stationName: "",
          list: [],
          roleIdList: [],
        },
        // {
        //   exceptionName: "客户地磅异常",
        //   exceptionId: 5,
        //   stationId: "",
        //   stationName: "",
        //   list: [],
        //   roleIdList: [],
        // },
        // {
        //   exceptionName: "司机扫泵异常",
        //   exceptionId: 6,
        //   stationId: "",
        //   stationName: "",
        //   list: [],
        //   roleIdList: [],
        // },
        {
          exceptionName: "司机泵送异常",
          exceptionId: 7,
          stationId: "",
          stationName: "",
          list: [],
          roleIdList: [],
        },
        {
          exceptionName: "工地过磅异常",
          exceptionId: 8,
          stationId: "",
          stationName: "",
          list: [],
          roleIdList: [],
        },
        {
          exceptionName: "司机回场未及时过磅异常",
          exceptionId: 9,
          stationId: "",
          stationName: "",
          list: [],
          roleIdList: [],
        },
        {
          exceptionName: "客户拒绝签收异常",
          exceptionId: 10,
          stationId: "",
          stationName: "",
          list: [],
          roleIdList: [],
        },
      ],
      roleList: [
        { id: "eada03f53e48471ca50cdbae1238675a", name: "站长" },
        { id: "354699968327585792", name: "责任前场" },
        { id: "354700057045504000", name: "值班前场" },
        { id: "12b2f6ff304148fd89141e9faa9afb96", name: "销售员" },
        { id: "48d84b503be7484ca1b5c2eade1ff004", name: "预算员" },
        { id: "22355b8155c24a458b7c32800e4bd8f9", name: "后场工长" },
      ],
      //余料比例设置 开始
      surplusMaterialForm: {
        id: "",
        proportion: "",
        graphicCalc: "",
        actualConclude: "",
        doubleControl: "",
        stationId: "",
        stationName: "",
      },
      surplusMaterialDig: false,
      surplusMaterialRules: {
        proportion: [{ required: true, message: "请输入比例", trigger: "blur" }],
        graphicCalc: [{ required: true, message: "请输入图算比例", trigger: "blur" }],
        actualConclude: [{ required: true, message: "请输入实结比例", trigger: "blur" }],
        doubleControl: [{ required: true, message: "请输入双控比例", trigger: "blur" }],
      },
      //余料比例设置  结束
      //产品设置 开始
      productDig: false,
      productData: [],
      //产品设置 结束
      //生产线设置 开始
      lineDig: false,
      lineData: [],
      lineList: [],
      groupNum: 1,
      oldGroupNum:1,
      oldLineData:[],
      //取样时间表单数据
      sampleTimeForm: {
        sampleTime: "",
        putOffSampleTime: ""
      },
      saveLoad: false,
      saveDisabled:true,
      //生产线设置 结束
      //富余量设置
      marginDig:false,
      marginForm:{
        stationId:"",
        limitNum:"",
      },
    };
  },
  async created() {
    this.treeData = await getUserAutList();
    this.activetree = this.treeData?.[0]?.children[0].value;
    this.activetreeName = this.treeData?.[0]?.children[0].label;
    this.tableParam.station = this.treeData?.[0]?.children[0].label;
    this.treeLoading = false;

    getDicType({ code: "market" }).then(res => {
      const newData = res.data.items.map(item => ({ ...item, type: 1 }));
      this.buspointtotal = this.buspointtotal.concat(newData);
    });
    getDicType({ code: "nomarket" }).then(res => {
      const newData = res.data.items.map(item => ({ ...item, type: 2 }));
      this.buspointtotal = this.buspointtotal.concat(newData);
    });
    getDicType({ code: "collaboration" }).then(res => {
      const newData = res.data.items.map(item => ({ ...item, type: 3 }));
      this.buspointtotal = this.buspointtotal.concat(newData);
    });
    getDicType({ code: "personaluse" }).then(res => {
      const newData = res.data.items.map(item => ({ ...item, type: 4 }));
      this.buspointtotal = this.buspointtotal.concat(newData);
    });
  },
  watch: {
    activenav: {
      handler() {
        let _this = this;
        getDicType({ code: _this.activenav }).then(res => {
          this.buspointarr = res.data.items;
        });
      },
      deep: true,
      immediate: true,
    },
    activetree: {
      handler() {
        this.getPointDetails();
      },
      deep: false,
      immediate: true,
    },
    lineData(val) {
      if(this.groupNum == this.oldGroupNum) {
       
        let type = true
        val.forEach((item,index) => {
          let lineName = JSON.stringify(item.lineList);
          console.log(lineName)
          if(lineName !== this.oldLineData[index].lineName){
            type= false
          }
        })
        this.saveDisabled = type
      } else {
        this.saveDisabled = false
      }
    },
  },
  methods: {
    //富余量设置
    marginSet(){
      this.marginForm.limitNum = ''
      this.marginForm.stationId = this.activetree
      queryLimit({ stationId: this.activetree }).then(res => {
        if (res.code == 1001) {
          this.marginForm = res.data || this.marginForm;
          this.marginDig = true
        }
      });
    },
    saveMargin() {
      this.saveLoad = true;
      saveLimit({ stationId: this.activetree, limitNum: this.marginForm.limitNum })
        .then(res => {
          if (res.code == 1001) {
            this.$message.success("保存成功!");
            this.marginDig = false;
          }
          this.saveLoad = false;
        })
        .catch(() => {
          this.saveLoad = false;
        });
    },
    //生产线开始
    setLineData() {
      this.lineData = [];
      for (var i = 1; i <= this.groupNum; i++) {
        this.lineData.push({
          groupNum: i,
          lineIdList: [],
          lineList: [],
          lineName: "",
        });
      }
    },
    groupInput(value) {
      var reg = /^(1|([1-9]\d{0,1})|100)$/;
      if (reg.test(value) == false) {
        this.groupNum = 1;
        return false;
      } else {
        this.groupNum = value;
      }
    },
    setLineList(index) {
      this.$nextTick(() => {
        let lineData = JSON.parse(JSON.stringify(this.lineData))
        lineData[index].lineList = [];
        lineData[index].lineIdList.forEach(item => {
          let line = this.lineList.find(item2 => item2.id == item);
          lineData[index].lineList.push(line);
        });
        this.lineData = lineData
        console.log(this.lineData[index].lineList);
      });
    },
    lineSet() {
      queryLineByStation({ stationId: this.activetree }).then(res => {
        if (res.code == 1001) {
          this.lineList = res.data;
        }
      });
      queryLineGroup({ stationId: this.activetree }).then(res => {
        if (res.code == 1001) {
          this.lineData = res.data;
          this.groupNum = res.data?.length || "";
          this.lineData?.forEach(item => {
            let list = JSON.parse(item.lineName);
            item.lineList = list;
            item.lineIdList = list.map(item => item.id);
          });
          this.oldGroupNum = this.groupNum
          this.oldLineData = JSON.parse(JSON.stringify(this.lineData))
          console.log(this.lineData);
          this.lineDig = true;
        }
      });
    },
    saveLine() {
      this.saveLoad = true;
      this.lineData.forEach(item => {
        item.lineName = JSON.stringify(item.lineList);
      });
      saveLineGroup({ stationId: this.activetree, list: this.lineData })
        .then(res => {
          if (res.code == 1001) {
            this.$message.success("保存成功!");
            this.lineDig = false;
          }
          this.saveLoad = false;
        })
        .catch(() => {
          this.saveLoad = false;
        });
    },
    //生产线结束
    //产品设置开始
    DeleteProduct(index) {
      this.productData.splice(index, 1);
    },
    addProduct() {
      let obj = {
        id: "",
        productName: "",
        whetherSend: 0,
        stationId: this.activetree,
      };
      this.productData.push(obj);
    },
    productSet() {
      queryProduct({ stationId: this.activetree }).then(res => {
        if (res.code == 1001) {
          this.productData = res.data;
          this.productDig = true;
        }
      });
    },
    saveProduct() {
      saveProduct({ stationId: this.activetree, list: this.productData }).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.productDig = false;
        }
      });
    },
    //产品设置结束
    //余料比例设置 -- 开始
    surplusMaterialSet() {
      selectCloutSetting({ stationId: this.activetree }).then(res => {
        if (res.code == 1001) {
          if (res.data.length > 0) {
            this.surplusMaterialForm = res.data[0];
          } else {
            this.surplusMaterialForm = this.$options.data().surplusMaterialForm;
          }
          this.surplusMaterialDig = true;
        }
      });
    },
    saveSurplusMaterial() {
      this.$refs.surplusMaterialForm.validate(valid => {
        if (valid) {
          this.surplusMaterialForm.stationId = this.activetree;
          this.surplusMaterialForm.stationName = this.activetreeName;
          updateCloutSetting(this.surplusMaterialForm).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功!");
              this.surplusMaterialDig = false;
            }
          });
        }
      });
    },
    //余料比例设置 -- 结束
    setList(index) {
      this.exceptionData[index].list = [];
      this.exceptionData[index].roleIdList.forEach(item => {
        let role = this.roleList.find(item2 => item2.id == item);
        let obj = {
          roleId: role.id,
          roleName: role.name,
        };
        this.exceptionData[index].list.push(obj);
      });
    },
    saveExceptionPerson() {
      this.exceptionData.forEach(item => {
        item.stationId = this.activetree;
        item.stationName = this.activetreeName;
      });
      saveExceptionUser({
        stationId: this.activetree,
        list: this.exceptionData,
      }).then(res => {
        if (res.code == 1001) {
          this.$message.success("设置成功!");
          this.exceptionPersonDig = false;
        }
      });
    },
    exceptionPerson() {
      getExceptionUser({ stationId: this.activetree }).then(res => {
        if (res.code == 1001) {
          let exceptionData = this.$options.data().exceptionData;
          res.data.forEach(item => {
            exceptionData.forEach(item2 => {
              if (item.exceptionId * 1 == item2.exceptionId) {
                item2.roleIdList = item.list.map(item3 => {
                  return item3.roleId;
                });
                item2.list = item.list;
                item2.stationId = item.stationId;
                item2.stationName = item.stationName;
              }
            });
          });
          this.exceptionData = JSON.parse(JSON.stringify(exceptionData));
          this.exceptionPersonDig = true;
        }
      });
    },
    getlist() {
      this.tableLoading = true;
      getPointData().then(res => {
        if (res.code === 1001) {
          if (res.data) {
            const newData = JSON.parse(res.data.servicePoint).map(item => item.id);
            this.buspointids = newData
            if (res.data.sampleTime) {
                let st = JSON.parse(res.data.sampleTime);
                this.sampleTimeForm.sampleTime = st.sampleTime ?? "";
                this.sampleTimeForm.putOffSampleTime = st.putOffSampleTime ?? "";
            }
          }
          this.tableLoading = false;
        }
      });
    },
    /**流程切换*/
    changenav(e) {
      this.activenav = e.code;
    },
    pagesaddFromDate(text) {
      this.addDialog = true;
      this.addDialogTitle = text;
      this.isAll = true;
      this.getlist();
    },
    /**
     * @Description: 如果isall为true则 设置默认，否则为设置站点
     * @Param:
     * @Author: wangwangwang
     */
    pagessubmitFromDate(isAll) {
      let baseUri = updatePointData;
      let data = this.buspointtotal.filter(res => this.buspointids.some(item => item == res.id));
      const newData = data.map(item => ({ id: item.id, name: item.itemName, type: item.type }));
      if (isAll) {
        baseUri = saveOrUpdate;
      }
      // 组装 sampleTime JSON 结构
      const sampleTimeObj = {
        sampleTime: this.sampleTimeForm.sampleTime ? Number(this.sampleTimeForm.sampleTime) : null,
        putOffSampleTime: this.sampleTimeForm.putOffSampleTime ? Number(this.sampleTimeForm.putOffSampleTime) : null
      };
      let params = {
        servicePoint: JSON.stringify(newData),
        stationId: this.activetree,
        sampleTime: JSON.stringify(sampleTimeObj)
      };
      baseUri(params).then(res => {
        if (res.code === 1001) {
          this.$message.success("保存成功");
          this.addDialog = false;
          this.getPointDetails();
        }
      });
    },
    getPointDetails() {
      if (!this.activetree) return;
      queryProcesses({ stationId: this.activetree }).then(res => {
        if (res.code === 1001) {
          const newData = JSON.parse(res.data.servicePoint).map(item => item.id);
          this.buspointids = newData;
          if (res.data.sampleTime) {
              let st = JSON.parse(res.data.sampleTime);
              this.sampleTimeForm.sampleTime = st.sampleTime ?? "";
              this.sampleTimeForm.putOffSampleTime = st.putOffSampleTime ?? "";
          } else {
             // 清空旧数据防污染
             this.sampleTimeForm.sampleTime = "";
             this.sampleTimeForm.putOffSampleTime = "";
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo-info {
  padding: 20px;
  display: flex;
  .a {
    width: 100px;
    flex: none;
  }
  .b {
    flex: 1;
    .checkbox-bg {
      margin: 0 10px 10px 10px;
      display: inline-block;
    }
  }
}
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border: 1px solid rgba(0, 0, 0, 0);
    border-bottom: 0;
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .active {
    background: #fff;
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border: 1px solid #e1e5ed;
    border-bottom: 0;
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
